import { useTranslation } from 'react-i18next';
import { FormControl, FormHelperText, Grid, InputLabel, MenuItem, Select, TextField } from '@mui/material';
import { OrganizationType } from '../../../types/organization.type';
import { requiresMwanFields } from '../../../types/organization-onboarding.type';
import { SAUDI_BANKS } from '../../../constants/saudiBanks';
import { FileUploadField } from '../FileUploadField';
import { OnboardingStepProps } from './OnboardingStep1Basics';

export function OnboardingStep2Compliance({ form, errors, setField }: OnboardingStepProps) {
  const { t } = useTranslation();
  const showMwan = requiresMwanFields(form.organization_type as OrganizationType | '');

  return (
    <Grid container spacing={2}>
      <Grid item xs={12} md={6}>
        <TextField
          fullWidth
          required
          label={t('onboarding.step2.crNumber')}
          value={form.cr_number}
          onChange={(e) => setField('cr_number', e.target.value)}
          error={Boolean(errors.cr_number)}
          helperText={errors.cr_number}
        />
      </Grid>
      <Grid item xs={12} md={6}>
        <FileUploadField
          label={t('onboarding.step2.crDocument')}
          required
          value={form.cr_document}
          onChange={(f) => setField('cr_document', f)}
          error={errors.cr_document}
        />
      </Grid>
      <Grid item xs={12} md={6}>
        <TextField
          fullWidth
          required
          label={t('onboarding.step2.vatNumber')}
          value={form.vat_number}
          onChange={(e) => setField('vat_number', e.target.value)}
          error={Boolean(errors.vat_number)}
          helperText={errors.vat_number}
        />
      </Grid>
      <Grid item xs={12} md={6}>
        <FileUploadField
          label={t('onboarding.step2.vatDocument')}
          required
          value={form.vat_document}
          onChange={(f) => setField('vat_document', f)}
          error={errors.vat_document}
        />
      </Grid>
      {showMwan ? (
        <>
          <Grid item xs={12} md={6}>
            <TextField
              fullWidth
              required
              label={t('onboarding.step2.mwanLicence')}
              value={form.mwan_license_number}
              onChange={(e) => setField('mwan_license_number', e.target.value)}
              error={Boolean(errors.mwan_license_number)}
              helperText={errors.mwan_license_number}
            />
          </Grid>
          <Grid item xs={12} md={6}>
            <FileUploadField
              label={t('onboarding.step2.mwanCertificate')}
              required
              value={form.mwan_certificate_document}
              onChange={(f) => setField('mwan_certificate_document', f)}
              error={errors.mwan_certificate_document}
            />
          </Grid>
        </>
      ) : null}
      <Grid item xs={12} md={6}>
        <FormControl fullWidth required error={Boolean(errors.bank_name)}>
          <InputLabel id="bank-label">{t('onboarding.step2.bankName')}</InputLabel>
          <Select
            labelId="bank-label"
            label={t('onboarding.step2.bankName')}
            value={form.bank_name || ''}
            onChange={(e) => setField('bank_name', e.target.value)}
          >
            <MenuItem value="">
              <em>{t('onboarding.step2.selectBank')}</em>
            </MenuItem>
            {SAUDI_BANKS.map((b) => (
              <MenuItem key={b} value={b}>
                {b}
              </MenuItem>
            ))}
          </Select>
          {errors.bank_name ? <FormHelperText>{errors.bank_name}</FormHelperText> : null}
        </FormControl>
      </Grid>
      <Grid item xs={12} md={6}>
        <TextField
          fullWidth
          required
          label={t('onboarding.step2.bankAccountNumber')}
          value={form.bank_account_number}
          onChange={(e) => setField('bank_account_number', e.target.value)}
          error={Boolean(errors.bank_account_number)}
          helperText={errors.bank_account_number}
        />
      </Grid>
      <Grid item xs={12} md={6}>
        <TextField
          fullWidth
          required
          label={t('onboarding.step2.iban')}
          value={form.iban}
          onChange={(e) => setField('iban', e.target.value)}
          error={Boolean(errors.iban)}
          helperText={errors.iban}
        />
      </Grid>
      <Grid item xs={12} md={6}>
        <FileUploadField
          label={t('onboarding.step2.ibanCertificate')}
          required
          value={form.iban_certificate_document}
          onChange={(f) => setField('iban_certificate_document', f)}
          error={errors.iban_certificate_document}
        />
      </Grid>
    </Grid>
  );
}
